export default [
  {
    path: '/Innovation/index',
    name: 'Innovation_index',
    component: () => import('@/views/Innovation/index'),
    meta: { title: "创新创业基础子平台", requireLogin: false }
  },
    {
    path: '/Innovation/components/consultation',
    name: 'Innovation_consultation',
    component: () => import('@/views/Innovation/components/consultation'),
    meta: { title: "资讯公告", requireLogin: false }
  },
    {
    path: '/Innovation/components/policyCenter',
    name: 'Innovation_policyCenter',
    component: () => import('@/views/Innovation/components/policyCenter'),
    meta: { title: "双创基地", requireLogin: false }
  },
    {
    path: '/Innovation/components/serviceOrganization',
    name: 'Innovation_serviceOrganization',
    component: () => import('@/views/Innovation/components/serviceOrganization'),
    meta: { title: "双创数据", requireLogin: false }
  },
    {
    path: '/Innovation/components/questionnaire',
    name: 'Innovation_questionnaire',
    component: () => import('@/views/Innovation/components/questionnaire'),
    meta: { title: "联系我们", requireLogin: false }
  },
    {
    path: '/Innovation/components/policyDetail',
    name: 'Innovation_policydetail',
    component: () => import('@/views/Innovation/components/policyDetail'),
    meta: { title: "双创基地详情", requireLogin: false }
  },
    {
    path: '/Innovation/components/noticeDetail',
    name: 'Innovation_noticeDetail',
    component: () => import('@/views/Innovation/components/noticeDetail'),
    meta: { title: "通知公告详情", requireLogin: false }
  },
    {
    path: '/Innovation/components/announcement',
    name: 'Innovation_announcement',
    component: () => import('@/views/Innovation/components/announcement'),
    meta: { title: "政策公告详情", requireLogin: false }
  },
    {
    path: '/Innovation/components/activeryDetail',
    name: 'Innovation_activeryDetail',
    component: () => import('@/views/Innovation/components/activeryDetail'),
    meta: { title: "活动报名详情", requireLogin: false }
  },
]
